import React, { useEffect, useState } from 'react';
import {Link} from "wouter"
interface Bubble {
  id: string;
  image: string;
  top: string;
  left?: string;
  right?: string;
  side: 'left' | 'right';
  delay: number;
}

interface Stat {
  label: string;
  icon: React.ReactNode;
}
import heroimg1 from '../../assets/images/hero-icon-1.png'
import heroimg2 from '../../assets/images/hero-icon-2.png'
import heroimg3 from '../../assets/images/hero-icon-3.png'
import heroimg4 from '../../assets/images/hero-icon-4.png'
import heroimg5 from '../../assets/images/hero-icon-5.png'
import heroimg6 from '../../assets/images/hero-icon-6.png'
import heroimg7 from '../../assets/images/hero-icon-7.png'
import heroimg8 from '../../assets/images/hero-icon-8.png'

/* =======================
   DESKTOP BUBBLES
======================= */
const bubblesDesktop: Bubble[] = [
  { id: 'b1', image: heroimg1, top: '9%', left: '6%', side: 'left', delay: 0 },
  { id: 'b2', image: heroimg2, top: '35%', left: '12%', side: 'left', delay: 200 },
  { id: 'b3', image: heroimg3, top: '9%', right: '12%', side: 'right', delay: 400 },
  { id: 'b4', image: heroimg4, top: '60%', left: '6%', side: 'left', delay: 600 },
  { id: 'b5', image: heroimg5, top: '35%', right: '8%', side: 'right', delay: 800 },
  { id: 'b6', image: heroimg6, top: '58%', right: '15%', side: 'right', delay: 1000 },
  { id: 'b7', image: heroimg7, top: '80%', left: '16%', side: 'left', delay: 1200 },
  { id: 'b8', image: heroimg8, top: '80%', right: '6%', side: 'right', delay: 1400 },
];

/* =======================
   MOBILE / TABLET BUBBLES
======================= */
const bubblesMobile: Bubble[] = [
  { id: 'b1', image: heroimg1, top: '9%', left: '1%', side: 'left', delay: 0 },
  { id: 'b2', image: heroimg2 ,top: '35%', left: '7%', side: 'left', delay: 200 },
  { id: 'b3', image: heroimg3, top: '9%', right: '7%', side: 'right', delay: 400 },
  { id: 'b4', image: heroimg4, top: '60%', left: '1%', side: 'left', delay: 600 },
  { id: 'b5', image: heroimg5, top: '35%', right: '3%', side: 'right', delay: 800 },
  { id: 'b6', image: heroimg6, top: '58%', right: '10%', side: 'right', delay: 1000 },
  { id: 'b7', image: heroimg7, top: '80%', left: '11%', side: 'left', delay: 1200 },
  { id: 'b8', image: heroimg8, top: '80%', right: '1%', side: 'right', delay: 1400 },
];

const stats: Stat[] = [
  {
    label: '80+ Languages',
    icon: (
      <svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.49945 7.34297L6.78558 3.1916C6.75393 3.11494 6.70023 3.04939 6.6313 3.00327C6.56236 2.95715 6.48128 2.93254 6.39834 2.93254C6.3154 2.93254 6.23433 2.95715 6.16539 3.00327C6.09645 3.04939 6.04276 3.11494 6.0111 3.1916L4.29724 7.34297C4.27592 7.39388 4.26488 7.4485 4.26474 7.50369C4.2646 7.55888 4.27537 7.61355 4.29643 7.66457C4.31748 7.71558 4.34841 7.76194 4.38743 7.80097C4.42646 7.83999 4.47281 7.87093 4.52382 7.89199C4.57483 7.91305 4.62951 7.92382 4.6847 7.92369C4.73989 7.92355 4.79451 7.91252 4.84542 7.89121C4.89633 7.86991 4.94253 7.83875 4.98137 7.79953C5.0202 7.76032 5.0509 7.71382 5.07171 7.6627L5.42077 6.81738H7.37591L7.72497 7.6627C7.75661 7.7394 7.81032 7.80498 7.87927 7.85112C7.94823 7.89726 8.02934 7.92189 8.1123 7.92188C8.18115 7.92183 8.24892 7.90483 8.30962 7.87236C8.37033 7.8399 8.4221 7.79297 8.46035 7.73574C8.49861 7.67851 8.52217 7.61273 8.52896 7.54422C8.53574 7.47572 8.52554 7.40659 8.49926 7.34297H8.49945ZM5.76678 5.97949L6.39844 4.44939L7.03009 5.97949H5.76678ZM4.49109 5.61615C4.55618 5.52625 4.58293 5.41419 4.56547 5.30458C4.54801 5.19497 4.48777 5.09677 4.39797 5.03153C4.39417 5.02868 4.11233 4.81958 3.7031 4.37017C4.45815 3.34794 4.88585 2.18499 5.06029 1.6377H5.6748C5.78592 1.6377 5.89248 1.59356 5.97104 1.51499C6.04961 1.43642 6.09375 1.32986 6.09375 1.21875C6.09375 1.10764 6.04961 1.00108 5.97104 0.922511C5.89248 0.843943 5.78592 0.799805 5.6748 0.799805H3.46582V0.418945C3.46582 0.307834 3.42168 0.201274 3.34311 0.122706C3.26455 0.0441387 3.15799 0 3.04688 0C2.93576 0 2.8292 0.0441387 2.75064 0.122706C2.67207 0.201274 2.62793 0.307834 2.62793 0.418945V0.799805H0.418945C0.307834 0.799805 0.201274 0.843943 0.122706 0.922511C0.0441387 1.00108 0 1.10764 0 1.21875C0 1.32986 0.0441387 1.43642 0.122706 1.51499C0.201274 1.59356 0.307834 1.6377 0.418945 1.6377H4.17517C3.99388 2.1509 3.66006 2.96118 3.15085 3.70119C2.55271 2.90748 2.33048 2.39389 2.32876 2.3897C2.28498 2.28851 2.20306 2.20865 2.10078 2.16746C1.99849 2.12627 1.8841 2.1252 1.78154 2.16506C1.67898 2.20492 1.59584 2.28351 1.54241 2.38345C1.48898 2.48338 1.47714 2.59913 1.50838 2.70818C1.87545 4.06482 2.47428 4.91489 3.24779 5.74453C2.64883 6.43379 1.94815 7.00762 1.15534 7.4271C0.866087 7.55988 0.7178 7.83685 0.828559 8.09079C0.939318 8.34472 1.18887 8.49805 1.47002 8.49805C1.65945 8.49805 1.85139 8.42699 1.99205 8.27688C2.97893 7.52869 3.87627 6.63097 4.57346 5.57778C5.27066 6.63097 6.168 7.52869 7.15488 8.27688C7.29554 8.42699 7.48748 8.49805 7.67691 8.49805C7.95806 8.49805 8.20761 8.34472 8.3184 8.09079C8.42916 7.83685 8.28084 7.55988 7.99159 7.4271C7.19877 7.00762 6.4981 6.43379 5.89914 5.74453C6.67265 4.91489 7.27148 4.06482 7.63855 2.70818C7.76265 2.20218 7.59903 1.66388 7.18699 1.4429C6.77494 1.22192 6.25146 1.36911 6.00766 1.80191C5.99949 1.8176 5.82168 2.23187 5.37239 2.87447C4.92311 2.23187 4.7453 1.8176 4.73713 1.80191C4.49333 1.36911 3.96984 1.22192 3.5578 1.4429C3.14575 1.66388 2.98213 2.20218 3.10623 2.70818C3.47331 4.06482 4.07214 4.91489 4.84565 5.74453C4.24669 6.43379 3.54601 7.00762 2.7532 7.4271C2.46395 7.55988 2.31562 7.83685 2.42638 8.09079C2.53714 8.34472 2.7867 8.49805 3.06785 8.49805C3.25728 8.49805 3.44922 8.42699 3.58988 8.27688C4.57676 7.52869 5.4741 6.63097 6.17129 5.57778C6.86849 6.63097 7.76583 7.52869 8.75271 8.27688C8.89337 8.42699 9.08531 8.49805 9.27474 8.49805C9.55589 8.49805 9.80544 8.34472 9.91621 8.09079C10.027 7.83685 9.87868 7.55988 9.58943 7.4271C8.79661 7.00762 8.09594 6.43379 7.49698 5.74453C8.27049 4.91489 8.86932 4.06482 9.23639 2.70818C9.36048 2.20218 9.19687 1.66388 8.78482 1.4429C8.37277 1.22192 7.84929 1.36911 7.60549 1.80191L4.49109 5.61615Z" fill="#64748B"/>
      </svg>
    ),
  },
  {
    label: 'Anonymous',
    icon: (
      <svg width="8" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.3125 4.0625C7.3125 6.31719 5.7525 8.42562 3.65625 8.9375C1.56 8.42562 0 6.31719 0 4.0625V1.625L3.65625 0L7.3125 1.625V4.0625ZM3.65625 8.125C5.17969 7.71875 6.5 5.90688 6.5 4.15188V2.15313L3.65625 0.885625L0.8125 2.15313V4.15188C0.8125 5.90688 2.13281 7.71875 3.65625 8.125Z" fill="#64748B"/>
      </svg>
    ),
  },
  {
    label: 'Real-Time',
    icon: (
      <svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.47996 8.39129L5.64821 4.5955H3.19932L3.64318 1.12113L0.811647 5.20773H2.93912L2.47996 8.39129ZM2.23752 5.81995H0.410028C0.243912 5.81995 0.123507 5.7475 0.0488161 5.60261C-0.0258752 5.45772 -0.0148552 5.31874 0.0818761 5.18569L3.52808 0.193002C3.59053 0.10525 3.66808 0.0470884 3.76073 0.0185179C3.85338 -0.0100525 3.95133 -0.00556298 4.0546 0.0319867C4.15786 0.0695365 4.23235 0.131575 4.27806 0.218103C4.32377 0.30463 4.3405 0.399117 4.32826 0.501562L3.89787 3.98328H6.0933C6.26472 3.98328 6.38615 4.06144 6.45757 4.21776C6.52941 4.37408 6.51002 4.51897 6.39941 4.65244L2.56444 9.24595C2.49914 9.3235 2.42037 9.37309 2.32813 9.39472C2.23548 9.41595 2.14405 9.40636 2.05385 9.36595C1.96365 9.32595 1.89467 9.26534 1.84692 9.18412C1.79957 9.1029 1.78223 9.01106 1.79488 8.90862L2.23752 5.81995Z" fill="#64748B"/>
      </svg>
    ),
  },
];

export default function HeroSection() {
  const [isMobile, setIsMobile] = useState(false);
  const [animatedBubbles, setAnimatedBubbles] = useState<number[]>([]);

  /* =======================
     SCREEN DETECTION
  ======================= */
  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 1024);

    check();
    window.addEventListener('resize', check);

    return () => window.removeEventListener('resize', check);
  }, []);

  /* reset animation on switch */
  useEffect(() => {
    setAnimatedBubbles([]);
  }, [isMobile]);

  const activeBubbles = isMobile ? bubblesMobile : bubblesDesktop;

  /* =======================
     ANIMATION TRIGGER
  ======================= */
  useEffect(() => {
    activeBubbles.forEach((bubble, i) => {
      setTimeout(() => {
        setAnimatedBubbles((prev) => [...prev, i]);
      }, 200 + bubble.delay);
    });
  }, [activeBubbles]);

  return (
    <div className="relative sm:min-h-[90vh] min-h-auto hero-sec sm:mt-16 mt-12 flex items-center justify-center overflow-hidden px-5 py-10 bg-[#F8FAFC]">
      <style>{`
        @keyframes floatUp {
          0%,100% { transform: translateY(0px); }
          50% { transform: translateY(-7px); }
        }

        @keyframes slideInFromLeft {
          0% { opacity:0; transform:translateX(-120px) scale(0.5); }
          70% { opacity:1; transform:translateX(6px) scale(1.05); }
          85% { transform:translateX(-3px) scale(0.98); }
          100% { opacity:1; transform:translateX(0) scale(1); }
        }

        @keyframes slideInFromRight {
          0% { opacity:0; transform:translateX(120px) scale(0.5); }
          70% { opacity:1; transform:translateX(-6px) scale(1.05); }
          85% { transform:translateX(3px) scale(0.98); }
          100% { opacity:1; transform:translateX(0) scale(1); }
        }

        .bubble-entered-left {
          animation:
            slideInFromLeft 1.5s cubic-bezier(0.22,1,0.36,1) forwards,
            floatUp 3s ease-in-out infinite 1.5s;
        }

        .bubble-entered-right {
          animation:
            slideInFromRight 1.5s cubic-bezier(0.22,1,0.36,1) forwards,
            floatUp 3s ease-in-out infinite 1.5s;
        }

        .bubble-hidden {
          opacity: 0;
        }

        @media(max-width:1024px){
          .bubble img{
            max-width:100px;
          }
        }

        @media(max-width:768px){
          .bubble img{
            max-width:80px;
          }
        }

        @media(max-width:640px){
          .bubble{
            display:none;
          }
        }
      `}</style>

      {/* BUBBLES */}
      {activeBubbles.map((b, i) => {
        const hasEntered = animatedBubbles.includes(i);

        const animClass = hasEntered
          ? b.side === 'left'
            ? 'bubble-entered-left'
            : 'bubble-entered-right'
          : 'bubble-hidden';

        return (
          <div
            key={b.id}
            className={`absolute bubble ${animClass}`}
            style={{
              top: b.top,
              left: b.left,
              right: b.right,
             
            }}
          >
            <img
              src={b.image}
              alt={`bubble-${b.id}`}
              className="w-full h-full object-cover"
            />
          </div>
        );
      })}

      {/* CENTER CONTENT */}
      <div
        className="relative z-10 text-center max-w-2xl mx-auto"
        style={{
          opacity: animatedBubbles.length > 0 ? 1 : 0,
          transform:
            animatedBubbles.length > 0
              ? 'translateY(0)'
              : 'translateY(20px)',
          transition: 'opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s',
        }}
      >
        <h1 className="font-bold text-[#0F172A] mb-4 xl:text-6xl sm:text-5xl text-[32px] leading-tight sm:leading-tight">
          Chat across languages,
          <span className="text-[#059669]"> instantly.</span>
        </h1>

        <p className="text-sm sm:text-base lg:text-lg text-[#64748B] my-8 max-w-xl mx-auto">
          Pick a name and start chatting in 80+ languages with context-aware translation. Built for travelers and global communities.
        </p>

        <div className="flex gap-8 justify-center flex-wrap my-14">
          <Link to='/app' className="bg-[#059669] text-white sm:px-6 px-3 py-2.5 rounded-lg font-semibold flex justify-center items-center gap-3 hover:scale-105 transition sm:text-base text-sm shadow-[4px_4px_0_0_#DF3838]">
            Start Chatting
            <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.0322 2.0342L3.61013 1.00011M12.0322 2.0342L10.9981 10.4562M12.0322 2.0342L1.00002 10.6535" stroke="#F8FAFC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </Link>

          <a href='#Chat' className="bg-[#6A35E0] text-white sm:px-6 px-3 py-2.5 rounded-lg font-semibold hover:scale-105 transition sm:text-base text-sm shadow-[4px_4px_0_0_#FF803E]">
            See How It Works
          </a>
        </div>

        <div className="flex sm:gap-12 gap-6 justify-center flex-wrap mt-8">
          {stats.map((s, i) => (
            <div key={i} className="flex flex-col items-center gap-2">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[rgba(15,23,42,0.2)] shadow-[2px_2px_0px_0px_#0f172a]">
                {s.icon}
              </div>
              <span className="text-sm text-[#64748B] font-semibold">
                {s.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
